import { ApiService } from "./apiService";

export const SocialNetworkService = ()=>{ 
    return {
        getAll: async ()=>{
            const response = await ApiService.get('/api/items/social_networks');
            return response.data;
        }
    }
}